import { CloseIcon } from '@chakra-ui/icons';
import {  useColorModeValue, Heading, Box, Stack, Text, FormControl,  Input, Flex,  HStack, Divider,  Button,  Spinner } from '@chakra-ui/react';
import { FormEvent, useCallback,  useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getShippByIdRequest, getShippByIdResponse, getUserByIdRequest, getUserResponse } from "../../../shared";
import {ENDPOINT_CONFIGS, withParams } from '../endpoints';
import { ApiError, callEndpoint } from '../fetch';
import { isAdmin, isCaptin, isLoggedIn } from '../fetch/auth';
import { ROUTES } from '../routes';
import { CHARGE_STATES, RECEIVE_OPTIONS, STATES, STATES_NAMES, USER_STATUS } from '../types';


  export const SearchShipp = ()=>{  
   const [error, setError] = useState('');
   const [searchId, setSearchId]= useState('');
   const [shipp, setShipp]= useState({});
   const [shippid, setShippId]= useState('');
   const [busy, setBusy] = useState(false);
   const navigate = useNavigate();
 const Admin=isAdmin();
 const is_captin = isCaptin();
 const [senderDetls, setSenderDtls] = useState('');
const [senderId, setSenderId]=useState('');
const [shippState, setShippState]= useState(0);

  const search = useCallback(
    async (e: FormEvent | MouseEvent) => {
      e.preventDefault();
  
      setBusy(true);
      setError('');
      if ((searchId.length !== 7) || !Number(searchId)){
       
        setError('Wrong id');   
        setShipp({});
        setBusy(false);
       return(<div></div>)
      }
      if (!isLoggedIn()) {
        navigate(ROUTES.SIGN_IN);
    }

      try{
        const res= await callEndpoint<getShippByIdRequest, getShippByIdResponse>(withParams(ENDPOINT_CONFIGS.getShipp, searchId!))
  
   
          setShipp({
            "كود الطرد":res.shipp.id,
            "حالة التنفيذ":STATES[res.shipp.state],
            ...(res.shipp.state>STATES_NAMES.WITH_CAPTIN)&&{"ملاحظات التنفيذ":res.shipp.execNotes},
            "كود الراسل":res.shipp.senderId,
            "عنوان الراسل":res.shipp.senderAddress,  
            "محتوى الطرد":res.shipp.description,           
            "اسم المستلم":res.shipp.conName,
            "عنوان المستلم":res.shipp.addrees,
            "تليفون المستلم":res.shipp.consMobile,
            "استلام مرتجع":RECEIVE_OPTIONS[res.shipp.receiveState],
            "وصف المرتجع":res.shipp.receiveDesc,          
            "القيمة شاملة الشحن":res.shipp.charge,     
            ...(res.shipp.state===STATES_NAMES.DELIVERD)&&{"قيمة الشحن":res.shipp.fees},
            ...(res.shipp.state===STATES_NAMES.DELIVERD)&&{"صافي المبلغ":(res.shipp.charge-res.shipp.fees)},
            ...(res.shipp.state===STATES_NAMES.DELIVERD)&&{"حالة التوريد":CHARGE_STATES[res.shipp.chargeState]},    
            ...(Admin)&&{"الكابتن":res.shipp.captinId},        
            "تاريخ الإنشاء":new Date(res.shipp.createTime).toISOString().split('T')[0],   
            "تاريخ آخر إجراء":new Date(res.shipp.excuteTime).toISOString().split('T')[0],
            "ملاحظات":res.shipp.notices
           
          })
          /*...(Admin)&&{"اﻷحداث":res.shipp.logs}*/
          setShippId(res.shipp.id);
          setSenderId(res.shipp.senderId);
          setShippState(res.shipp.state);
          setBusy(false);
         } catch (e) {
           setError((e as ApiError).message);
           setShippId('');
           setShipp({});
           setBusy(false);
         }
  
        

    },
    [searchId,navigate,shipp,shippid]
  );

  const getUserDetails = useCallback(
    async (e: FormEvent | MouseEvent) => {
      e.preventDefault();

      try{
        const res= await callEndpoint<getUserByIdRequest, getUserResponse>(withParams(ENDPOINT_CONFIGS.getUserById, senderId ))
        setSenderDtls(res.name+'-'+res.address+'-'+res.phone+'-'+USER_STATUS[res.status]);

      }catch{
        setSenderDtls('');
      }

    },
    [shipp]
  );

  
return(
      <div>
     <Flex  dir='rtl'
        minH={'100vh'}

        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}>
        <Stack spacing={5} w={'full'} mx={'auto'} maxW={'lg'} py={5} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'2xl'} textAlign={'center'}>
              بحث عن طرد
            </Heading>           
          </Stack>
          <Box
         rounded={'lg'}
         bg='white'
         boxShadow={'lg'}
         p={8}>  
        <Stack spacing={1}>
          <form onSubmit={search} >
          <fieldset disabled={busy}>
            <HStack paddingBottom={4}>
                <Box width={'full'}>
                  <FormControl id="searchid" isRequired>
                    <Input autoFocus={true} type="text" placeholder={'أدخل رقم الطرد'} onChange={e => setSearchId(e.target.value)}/>
                  </FormControl>
                </Box>
                <Box>
                <Button
                type='submit'               
                  loadingText="Submitting"
                  size="md"
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }} >
                  بحث
                </Button>
                {busy &&  
          <Stack pt={4}>
            <Spinner  alignSelf={'center'} />
            </Stack>
            }
                </Box>            
            </HStack>  
            </fieldset>       
            </form>

         

            {!!error &&
               <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                <CloseIcon boxSize={'20px'} color={'white'} />
               <Text color="red.700">{error}</Text>             
               </Stack>
}

            {Object.keys(shipp).map((key,i)=>(
              <div key={i}>
              <Flex id="id"direction={'row'}>                               
              <Text size={'xl'} fontWeight={'bold'} paddingLeft={1}>{key}:</Text>
              <Text onClick={key==='كود الراسل'? getUserDetails:undefined} 
              cursor={key==='كود الراسل'? 'pointer':undefined} 
              color={key==='كود الراسل'? 'blue':'gray.600' } 
              
              size={'md'}
               pl={2}
               >{shipp[key]}</Text>   
            </Flex>
            {(!!senderDetls && key==='كود الراسل') &&
              
              <Text>{senderDetls}</Text>  
              }
            <Divider orientation='horizontal' />  
             </div>
            ))}
</Stack>

</Box>
{!!shippid &&
<Stack direction={'row'} justifyContent={'center'} spacing={8}>
  {((Admin || (is_captin&&shippState==2))) &&
<a href={ROUTES.UPDATE_SHIPP(shippid)}>تحديث</a>
}
{(shippState !==4 && !is_captin)&&
<Link
  to={ROUTES.EDIT_SHIPP}
  state={{shipp:shippid}}
>تعديل</Link>
  }
</Stack>
  }
         
        </Stack>

      </Flex>
</div>
);
};


/*
<Flex id="desc"direction={'row'}>                                         
<Text size={'xl'} fontWeight={'bold'}>Description: </Text>
<Text color='gray.600' size={'md'} px={2}>{shipp.description}</Text>                                                  
</Flex>
<Divider orientation='horizontal' />  

<Flex id="adress"direction={'row'}>                                         
<Text size={'xl'} fontWeight={'bold'}>Address: </Text>
<Text color='gray.600' size={'md'} pl={2}>{shipp.addrees}</Text>                                                  
</Flex>
<Divider orientation='horizontal' />  

<Flex id="conphone"direction={'row'}>                                         
<Text size={'xl'} fontWeight={'bold'}>Con Phone: </Text>
<Text color='gray.600' size={'md'} pl={2}>{shipp.consMobile}</Text>                                                  
</Flex>
<Divider orientation='horizontal' />  

<Flex id="charge"direction={'row'}>                                         
<Text size={'xl'} fontWeight={'bold'}>Charge: </Text>
<Text color='gray.600' size={'md'} pl={2}>{shipp.charge}</Text>                                                  
</Flex>
<Divider orientation='horizontal' />  

<Flex id="suitdate"direction={'row'}>                                         
<Text size={'xl'} fontWeight={'bold'}>suitable Date: </Text>
<Text color='gray.600' size={'md'}  pl={2}>{new Date(shipp.suitableTime).toISOString().split('T')[0]}</Text>                                                  
</Flex>
<Divider orientation='horizontal' /> 

<Flex id="notes"direction={'row'}>                                         
<Text size={'xl'} fontWeight={'bold'}>Notices: </Text>
<Text color='gray.600' size={'md'} pl={2}>{shipp.notices}</Text>                                                  
</Flex>
<Divider orientation='horizontal' />  */


/*import { Text, Flex, Input, Button, Checkbox, GridItem, Heading, Select, SimpleGrid, VStack } from "@chakra-ui/react";
import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
  } from '@chakra-ui/react'
import { Shippment } from "../../../Shared";

export const ShippCard: React.FC<Shippment> =(shipp)=>{
return(
    <div>
 <VStack w="full" h="full" p={10} spacing={10} alignItems="flex-start" >
      <VStack spacing={3} alignItems="flex-start">
        <Heading size="2xl">Your details</Heading>
        <Text>If you already have an account, click here to log in.</Text>
      </VStack>
      <SimpleGrid columns={2} columnGap={3} rowGap={6} w="full">
        <GridItem colSpan={1}>
          <FormControl>
            <FormLabel>First Name</FormLabel>
            <Input placeholder="John" />
          </FormControl>
        </GridItem>
        <GridItem colSpan={1}>
          <FormControl>
            <FormLabel>Last Name</FormLabel>
            <Input placeholder="Doe" />
          </FormControl>
        </GridItem>
        <GridItem colSpan={2}>
          <FormControl>
            <FormLabel>Address</FormLabel>
            <Input placeholder="Blvd. Broken Dreams 21" />
          </FormControl>
        </GridItem>
        <GridItem colSpan={1}>
          <FormControl>
            <FormLabel>City</FormLabel>
            <Input placeholder="San Francisco" />
          </FormControl>
        </GridItem>
        <GridItem colSpan={1}>
          <FormControl>
            <FormLabel>Country</FormLabel>
            <Select>
              <option value="usa">United States of America</option>
              <option value="uae">United Arab Emirates</option>
              <option value="nmk">North Macedonia</option>
              <option value="de">Germany</option>
            </Select>
          </FormControl>
        </GridItem>
        <GridItem colSpan={2}>
          <Checkbox defaultChecked>Ship to billing address.</Checkbox>
        </GridItem>
        <GridItem colSpan={2}>
          <Button size="lg" w="full">
            Place Order
          </Button>
        </GridItem>
      </SimpleGrid>
    </VStack>
</div>
);
};*/